import styled from 'styled-components';

export const CheckBoxContainer = styled.div`
    display: flex;
    align-items: center;
`